import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/budget-item?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/budget-item', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/budget-item/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/budget-item/${body.id}`, body.body);
};